import { render, staticRenderFns } from "./PopoverNd.vue?vue&type=template&id=1a71c85e"
import script from "./PopoverNd.vue?vue&type=script&lang=js"
export * from "./PopoverNd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports